const configuredImagesUrl = process.env.NEXT_PUBLIC_IMAGES_URL
const configuredImageUrl = configuredImagesUrl ? new URL(configuredImagesUrl) : undefined
const configuredImageOrigin = configuredImageUrl?.origin
const configuredImageHost = configuredImageUrl?.host

/** Browser display scaling used by the legacy image cards; SSR uses 1x. */
export function getImageScale(): number {
  if (typeof window === 'undefined') return 1
  const mq = window.matchMedia(
    'only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)',
  )
  return (mq && mq.matches) || window.devicePixelRatio > 1 ? 2 : 1
}

/** Legacy Cloudflare/Cloudinary crop behavior; does not apply the Next width cap. */
export function imageTransform(
  url: string | null | undefined,
  width: number,
  height: number,
  scale?: number,
): string {
  if (!url) return ''
  const imageScale = scale ?? getImageScale()
  let imageHost = url.includes('img.teamfeedr.com') ? 'img.teamfeedr.com' : undefined
  if (!imageHost && configuredImageOrigin && url.startsWith(`${configuredImageOrigin}/`)) {
    imageHost = configuredImageHost
  }
  if (imageHost) {
    const [pre, post] = url.split(imageHost)
    return `${pre}${imageHost}/cdn-cgi/image/width=${width * imageScale},height=${height * imageScale},quality=100,format=auto,fit=cover${post}`
  }
  if (url.includes('cloudinary')) {
    const [pre, post] = url.split('/image/upload/')
    return `${pre}/image/upload/w_${width * imageScale},h_${height * imageScale},c_fill/${post}`
  }
  return url
}
